import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import ReportCard from "./ReportCard";
import { getCrewSearchList, getShipnameList } from "../Actions/HelpersAPI";
import Role from "../helpers/role";
import { getShipName } from "../Actions/ShipViewAPI";
import DatePicker from "react-datepicker";
import Moment from "moment";
import Autocomplete from "react-autocomplete";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import swal from "sweetalert";
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { AiOutlineClose } from "react-icons/ai";
import * as $ from "jquery";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
  DateTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { ReactMultiEmail } from "react-multi-email";
import Icon from "@material-ui/core/Icon";
import { getTimezonenameList } from "../Actions/HelpersAPI";
import { showLoader, hideLoader } from "../Actions/PageLoaderAPI";
import MonthlyreportCards from "./MonthlyreportCards";

let user = JSON.parse(localStorage.getItem("currentUser"));
let userRole = localStorage.getItem("UserRoles");
const fontStyles = { fontSize: "20px" };

class MonthlyReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      SelectedFromDate: "",
      SelectedToDate: "",
      searchData: {
        shipId: 0,
        actionBy: user.email,
        remark: "",
        shipName: "",
        fromDate: "",
        toDate: "",
      },
      generateData: {
        remark: "",
        receivedDate: new Date().toISOString(),
        testcompletedDate: new Date().toISOString(),
        location: "",
        initiatedBy: "",
        testadmin: "",
        witness1: "",
        witness2: "",
        excludeFail: false,
        sendtomail: false,
        tomail: "",
        timeZoneId: "",
      },
      isMobile: false,
      openShipName: false,
      InvalidToMail: [],
      tomail: [],
      verifytomail: [],
      reportsData: null,
      staffShipId: 0,
      staffShipName: "",
    };
    this.SearchCrew = this.SearchCrew.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Monthly Reports" });
    if (match?.params?.id) {
      this.state.searchData.crewId = match.params.id;
    }
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
    if (userRole == Role.staff) {
      axios
        .get(`${API.shipInfo}?staffmail=${user.email}&shipId=0`)
        .then((res) => {
          const shipId = parseInt(res?.data?.shipId ?? res?.data?.shipID ?? 0);
          const shipName = res?.data?.shipName ?? "";
          this.setState(
            (prev) => ({
              staffShipId: shipId,
              staffShipName: shipName,
              searchData: {
                ...prev.searchData,
                shipId: shipId,
                shipName: shipName,
              },
            }),
            () => {
              this.GetReportList(1);
            },
          );
        })
        .catch(() => {
          this.GetReportList(1);
        });
      return;
    }
    this.GetReportList(1);
    // dispatch(getShipnameList());
  }
  resize = () => {
    if (window.innerWidth < 590) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  GetReportList = (value) => {
    const { dispatch } = this.props;
    const { fromDate, toDate } = this.state.searchData;

    const startDate = fromDate
      ? Moment(fromDate, "MMMM YYYY").startOf("month").format("YYYY-MM-DD")
      : "";

    const endDate = toDate
      ? Moment(toDate, "MMMM YYYY").endOf("month").format("YYYY-MM-DD")
      : "";
    const selectedShipId = parseInt(this.state.searchData.shipId) || 0;
    const fallbackShipId = parseInt(this.state.staffShipId) || 0;
    const payloadShipId =
      userRole == Role.staff ? selectedShipId || fallbackShipId : selectedShipId;
    const payloadShipName =
      userRole == Role.staff
        ? this.state.searchData.shipName || this.state.staffShipName || null
        : this.state.searchData.shipName || null;

    let data = {
      pageNumber: value,
      pageSize: 25,
      shipId: payloadShipId,
      remarks: this.state.searchData.remark,
      startDate: startDate,
      //   startDate: this.state.searchData.fromDate,
      endDate: endDate,
      //   endDate: this.state.searchData.toDate,
      actionBy: this.state.searchData.actionBy,
      shipName: payloadShipName,
    };
    let url = `${API.GetMonthlyReport}`;
    // dispatch(showLoader());
    axios
      .post(url, data)
      .then((response) => {
        this.setState({
          reportsData: response.data,
        });
        // dispatch({
        //   type: "getReportListSuccess",
        //   data: response.data,
        // });
        dispatch(getTimezonenameList());
        dispatch(getShipnameList());
        // dispatch(hideLoader());
      })
      .catch((error) => {
        dispatch({
          type: "getReportListFailure",
          error: "ERROR",
        });
        // dispatch(hideLoader());
      });
  };
  SearchCrew(pgno) {
    const { dispatch } = this.props;
    if (
      this.state.searchData.toDate !== "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the from month", "warning");
    }
    if (this.state.searchData.toDate === "") {
      if (this.state.searchData.fromDate > Moment().format("YYYY-MM-DD")) {
        swal("Error!", "Please select the to month", "warning");
      }
    }
    if (
      this.state.searchData.fromDate !== "" &&
      this.state.searchData.toDate === "" &&
      this.state.searchData.fromDate < Moment().format("YYYY-MM-DD")
    ) {
      this.state.searchData.toDate = Moment().format("YYYY-MM-DD");
      this.setState({});
      this.state.searchData.PageNumber = pgno;
      this.GetReportList(1);
    }
    if (
      (this.state.searchData.fromDate === "" &&
        this.state.searchData.toDate === "") ||
      (this.state.searchData.fromDate !== "" &&
        this.state.searchData.toDate !== "")
    ) {
      this.state.searchData.PageNumber = pgno;
      this.GetReportList(1);
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  //   handleFromDateChange(date) {
  //     this.state.searchData.fromDate = Moment(new Date(Date.parse(date))).format(
  //       "YYYY-MM-DD",
  //     );
  //     this.setState({
  //       SelectedFromDate: date,
  //       fromDatePickerIsOpen: false,
  //     });
  //   }

  handleFromDateChange = (date) => {
    if (!date) return;

    const normalized = Moment(date).startOf("month").toDate();

    this.setState((prev) => ({
      SelectedFromDate: normalized,
      fromDatePickerIsOpen: false,
      searchData: {
        ...prev.searchData,
        fromDate: Moment(normalized).format("MMMM YYYY"),
      },
    }));
  };
  handleToDateChange = (date) => {
    if (!date) return;

    const normalized = Moment(date).startOf("month").toDate();

    this.setState((prev) => ({
      SelectedToDate: normalized,
      toDatePickerIsOpen: false,
      searchData: {
        ...prev.searchData,
        toDate: Moment(normalized).format("MMMM YYYY"),
      },
    }));
  };
  //   handleToDateChange(date) {
  //     this.state.searchData.toDate = Moment(new Date(Date.parse(date))).format(
  //       "YYYY-MM-DD",
  //     );
  //     this.setState({
  //       SelectedToDate: date,
  //       toDatePickerIsOpen: false,
  //     });
  //   }
  openFromDatePicker = () => {
    this.setState({
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
      toDatePickerIsOpen: false,
    });
  };
  openToDatePicker = () => {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  };

  ClearInput() {
    this.state.SelectedFromDate = "";
    this.state.SelectedToDate = "";
    this.state.searchData.remark = "";
    if (userRole == Role.staff) {
      this.state.searchData.shipId = this.state.staffShipId || 0;
      this.state.searchData.shipName = this.state.staffShipName || "";
    } else {
      this.state.searchData.shipId = 0;
      this.state.searchData.shipName = "";
    }
    this.state.searchData.fromDate = "";
    this.state.searchData.toDate = "";
    this.GetReportList(1);
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    const { dispatch } = this.props;
    this.state.searchData[field] = value;
    this.state.searchData[fieldId] = id;
    this.setState({});
  };
  deleteReport(item) {
    const { dispatch, history } = this.props;
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let url = `${API.DeleteReport}?id=${item.id}&actionBy=${user.email}`;
            axios
              .delete(url)
              .then((response) => {
                if (response.status === 200) {
                  this.setState({ showSidePane: false });
                  this.GetReportList(1);
                  dispatch({
                    type: "UpdateReportDetailSuccess",
                    data: response.data,
                  });
                  toast.success("Deleted Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
              })
              .catch((error) => {
                swal(
                  "Error!",
                  "Something went wrong. Please try again.",
                  "warning",
                );
                dispatch({
                  type: "UpdateReportDetailFailure",
                  data: "error",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
      overlayClassName: "custom-alert",
    });
  }
  BacktoPrevious() {
    this.props.history.goBack();
  }

  // generate reports

  handleInputChangeReport(e) {
    let nodeName = e.target.name;
    this.state.generateData[nodeName] = e.target.value;
    this.setState({});
  }

  GenerateReport() {
    if (
      this.state.searchData.shipName === "" &&
      this.state.searchData.toDate === "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the shipname and date", "warning");
      return;
    }
    if (this.state.searchData.shipName === "") {
      swal("Error!", "Please select the shipname", "warning");
      return;
    }
    if (
      this.state.searchData.toDate === "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the date", "warning");
      return;
    }
    if (
      this.state.searchData.toDate !== "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the from date", "warning");
      return;
    }
    if (
      this.state.searchData.fromDate != "" &&
      this.state.searchData.toDate === ""
    ) {
      swal("Error!", "Please select the to date", "warning");
      return;
    }

    this.setState({ modalIsOpen: !this.state.modalIsOpen });
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.state.generateData.excludeFail = true;
      this.setState({});
    } else {
      this.state.generateData.excludeFail = false;
      this.setState({});
    }
  }

  handleEmailCheckBoxChange(e) {
    if (e.target.checked) {
      this.state.generateData.sendtomail = true;
      this.setState({});
    } else {
      this.state.generateData.sendtomail = false;
      this.setState({});
    }
  }

  HandlePicker(str, e) {
    if (str == "testdatetime") {
      let datetime = new Date(Date.parse(e)).toISOString();
      let value = Moment.utc(datetime).local().format();
      this.state.generateData.testcompletedDate = value;
    }
    if (str == "receiveddatetime") {
      let datetime = new Date(Date.parse(e)).toISOString();
      let value = Moment.utc(datetime).local().format();
      this.state.generateData.receivedDate = value;
    }
  }

  validateToEmail = async (email) => {
    email.map((item) => {
      if (item !== "") {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (item.match(mailformat)) {
        } else {
          var c = this.state.InvalidToMail.push(item);
          this.setState(
            {
              InvalidToMail: this.state.InvalidToMail,
            },
            () => {
              console.log(this.state.InvalidToMail);
              console.log(this.state.tomail);
            },
          );
        }
      }
    });
  };

  submitGenerateData = () => {
    if (
      this.state.generateData.remark === "" ||
      this.state.generateData.location === "" ||
      this.state.generateData.receivedDate === "" ||
      this.state.generateData.testcompletedDate === "" ||
      this.state.generateData.initiatedBy === "" ||
      this.state.generateData.testadmin === "" ||
      this.state.generateData.witness1 === "" ||
      this.state.generateData.witness2 === "" ||
      this.state.generateData.timeZoneId === ""
    ) {
      this.state.generateData.remark === ""
        ? $("#chargeDescriptionErrMsg").text("This field is required")
        : $("#chargeDescriptionErrMsg").text("");
      this.state.generateData.location === ""
        ? $("#locationErrMsg").text("This field is required")
        : $("#locationErrMsg").text("");
      this.state.generateData.receivedDate === ""
        ? $("#receivedDateErrMsg").text("This field is required")
        : $("#receivedDateErrMsg").text("");
      this.state.generateData.testcompletedDate === ""
        ? $("#testcompletedDateErrMsg").text("This field is required")
        : $("#testcompletedDateErrMsg").text("");
      this.state.generateData.timeZoneId === ""
        ? $("#timezoneErrMsg").text("This field is required")
        : $("#timezoneErrMsg").text("");
      this.state.generateData.initiatedBy === ""
        ? $("#initiatedByErrMsg").text("This field is required")
        : $("#initiatedByErrMsg").text("");
      this.state.generateData.testadmin === ""
        ? $("#testadminErrMsg").text("This field is required")
        : $("#testadminErrMsg").text("");
      this.state.generateData.witness1 === ""
        ? $("#witness1ErrMsg").text("This field is required")
        : $("#witness1ErrMsg").text("");
      this.state.generateData.witness2 === ""
        ? $("#witness2ErrMsg").text("This field is required")
        : $("#witness2ErrMsg").text("");
      return;
    } else {
      $("#chargeDescriptionErrMsg").text("");
      $("#locationErrMsg").text("");
      $("#receivedDateErrMsg").text("");
      $("#testcompletedDateErrMsg").text("");
      $("#initiatedByErrMsg").text("");
      $("#testadminErrMsg").text("");
      $("#witness1ErrMsg").text("");
      $("#witness2ErrMsg").text("");
      $("#timezoneErrMsg").text("");
    }
    this.state.InvalidToMail = [];
    let a = [$("div.tomail>input").val()];
    var b = [];
    if (a[0]) {
      b = a.concat(this.state.tomail);
    }
    if (b.length !== 0) {
      this.state.verifytomail = b;
    } else {
      this.state.verifytomail = this.state.tomail;
    }

    if (this.state.generateData.sendtomail) {
      if (this.state.verifytomail?.length === 0) {
        $("#tomailErrMsg").text("This field is required");
        return;
      } else {
        $("#tomaiErrMsg").text("");
      }
    }
    if (this.state.verifytomail?.length !== 0) {
      this.validateToEmail(b);
      console.log(this.state.InvalidToMail.length);
      if (this.state.InvalidToMail.length > 0) {
        swal("Error!", "Invalid tomail", "warning");
        return;
      }
    }
    let result = {
      shipId: parseInt(this.state.searchData.shipId),
      remarks: this.state.generateData.remark,
      startDate: this.state.searchData.fromDate,
      endDate: this.state.searchData.toDate,
      actionBy: user.email,
      shipName: this.state.searchData.shipName,
      data: {
        location: this.state.generateData.location,
        instructionDate: Moment(
          new Date(Date.parse(this.state.generateData.receivedDate)),
        ).format("YYYY-MM-DD HH:mm"),
        testCompletedDate: Moment(
          new Date(Date.parse(this.state.generateData.testcompletedDate)),
        ).format("YYYY-MM-DD HH:mm"),
        initiatedBy: this.state.generateData.initiatedBy,
        testAdmin: this.state.generateData.testadmin,
        witnessOne: this.state.generateData.witness1,
        witnessTwo: this.state.generateData.witness2,
        excludeFail: this.state.generateData.excludeFail,
        email: this.state.tomail
          ? this.state.tomail.length === 0
            ? null
            : this.state.tomail.toString()
          : null,
        timeZoneId: parseInt(
          this.state.generateData.timeZoneId
            ? this.state.generateData.timeZoneId
            : 0,
        ),
      },
    };
    let url = `${API.AddReport}`;
    axios
      .post(url, result)
      .then((response) => {
        if (response.data) {
          this.clearModelData();
          this.state.tomail = [];
          this.state.InvalidToMail = [];
          this.state.verifytomail = [];
          this.setState({ modalIsOpen: false });
          swal("Success!", "Report Details added successfully", "success");
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
          swal("Error!", error.response.data, "warning");
        } else {
          swal("Error!", "Something went wrong. Please try again.", "warning");
        }
        console.log("Error in Add settings Visitor" + error);
      });
  };

  clearModelData = () => {
    this.state.searchData.shipName = "";
    this.state.searchData.fromDate = "";
    this.state.searchData.toDate = "";
    this.state.SelectedFromDate = "";
    this.state.SelectedToDate = "";
    this.state.searchData.shipId = 0;
    this.setState(
      {
        generateData: {
          remark: "",
          location: "",
          initiatedBy: "",
          testadmin: "",
          witness1: "",
          witness2: "",
          timeZoneId: "",
          excludeFail: false,
          sendtomail: false,
          receivedDate: new Date().toISOString(),
          testcompletedDate: new Date().toISOString(),
        },
        modalIsOpen: !this.state.modalIsOpen,
      },
      () => {
        console.log(this.state.generateData);
      },
    );
  };

  render() {
    const { ShipNameList, ReportList } = this.props;
    const { Loading, TimeZoneNameList } = this.props;
    const { tomail, reportsData } = this.state;
    return (
      <>
        <div className="pb-3">
          <Modal
            size="lg"
            show={this.state.modalIsOpen}
            onHide={() => this.setState({ modalIsOpen: false })}
            aria-labelledby="example-modal-sizes-title-sm"
            backdrop="static"
            centered="true"
            animation="true"
          >
            <div className="px-4 py-4">
              <label className="fo-title">Report Details</label>
              <AiOutlineClose
                className="close"
                style={fontStyles}
                onClick={() => this.clearModelData()}
              />
              <div
                style={{
                  borderBottom: "2px solid #1E3A8A",
                  paddingTop: 5,
                }}
              ></div>
              <div
                className="px-4 pb-2"
                style={{
                  backgroundColor: "#F9F9F9",
                  borderRadius: 0,
                  border: "none",
                }}
              >
                <div className="row pt-3">
                  <div className="col-sm-4">
                    <label className="form-label fontstyle required">
                      Location
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="location"
                      value={this.state.generateData.location}
                      onChange={(e) => this.handleInputChangeReport(e)}
                    ></input>
                    <span
                      id="locationErrMsg"
                      className="spanErrMsg ml-2"
                    ></span>
                  </div>
                  <div className="col-sm-4">
                    <label className="form-label fontstyle required">
                      Instruction Received Date
                    </label>
                    <br></br>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        autoOk={true}
                        ampm={false}
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control"
                        format="yyyy/MM/dd HH:mm"
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        keyboardIcon={
                          <Icon
                            className="fa fa-calendar"
                            style={{ fontSize: "18px" }}
                          />
                        }
                        value={this.state.generateData.receivedDate}
                        size="small"
                        onChange={(e) =>
                          this.HandlePicker("receiveddatetime", e)
                        }
                      />
                      <span className="spanErrMsg ml-2">
                        Note:Please select UTC time
                      </span>
                      <span
                        id="receivedDateErrMsg"
                        className="spanErrMsg ml-2"
                      ></span>
                    </MuiPickersUtilsProvider>
                  </div>

                  <div className="col-sm-4">
                    <label className="form-label fontstyle required">
                      Test Completed Date
                    </label>
                    <br></br>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        ampm={false}
                        autoOk={true}
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control"
                        format="yyyy/MM/dd HH:mm"
                        KeyboardButtonProps={{
                          "aria-label": "change complete date",
                        }}
                        keyboardIcon={
                          <Icon
                            className="fa fa-calendar"
                            style={{ fontSize: "18px" }}
                          />
                        }
                        value={this.state.generateData.testcompletedDate}
                        size="small"
                        onChange={(e) => this.HandlePicker("testdatetime", e)}
                      />
                      <span className="spanErrMsg ml-2">
                        Note:Please select UTC time
                      </span>
                      <span
                        id="testcompletedDateErrMsg"
                        className="spanErrMsg ml-2"
                      ></span>
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <label className="form-label fontstyle required">
                      Time Zone
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="timeZoneId"
                      value={this.state.generateData.timeZoneId}
                      onChange={(e) => this.handleInputChangeReport(e)}
                    >
                      <option value="">Select Time Zone</option>
                      {TimeZoneNameList &&
                        TimeZoneNameList.map((i) => (
                          <option value={i.id}>{i.timeZoneName}</option>
                        ))}
                    </select>
                    <span
                      id="timezoneErrMsg"
                      className="spanErrMsg ml-2"
                    ></span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <label className="form-label fontstyle required">
                      Test Initiated By
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="initiatedBy"
                      value={this.state.generateData.initiatedBy}
                      onChange={(e) => this.handleInputChangeReport(e)}
                    ></input>
                    <span
                      id="initiatedByErrMsg"
                      className="spanErrMsg ml-2"
                    ></span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <label className="form-label fontstyle required">
                      Test Administrator
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="testadmin"
                      value={this.state.generateData.testadmin}
                      onChange={(e) => this.handleInputChangeReport(e)}
                    ></input>
                    <span
                      id="testadminErrMsg"
                      className="spanErrMsg ml-2"
                    ></span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <label className="form-label fontstyle required">
                      Witness #1
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="witness1"
                      value={this.state.generateData.witness1}
                      onChange={(e) => this.handleInputChangeReport(e)}
                    ></input>
                    <span
                      id="witness1ErrMsg"
                      className="spanErrMsg ml-2"
                    ></span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <label className="form-label fontstyle required">
                      Witness #2
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="witness2"
                      value={this.state.generateData.witness2}
                      onChange={(e) => this.handleInputChangeReport(e)}
                    ></input>
                    <span
                      id="witness2ErrMsg"
                      className="spanErrMsg ml-2"
                    ></span>
                  </div>
                  <div className="col-lg-2 mt-2">
                    <label className="form-label fontstyle">Exclude Fail</label>
                    <br></br>
                    <input
                      type="checkbox"
                      name="excludefail"
                      style={{ height: "15px", width: "15px" }}
                      checked={this.state.generateData.excludeFail}
                      onChange={(e) => this.handleCheckBoxChange(e)}
                    ></input>
                  </div>
                  <div className="col-lg-2 mt-2">
                    <label className="form-label fontstyle">
                      Send Email Notification
                    </label>
                    <br></br>
                    <input
                      type="checkbox"
                      name="sendtomail"
                      style={{ height: "15px", width: "15px" }}
                      checked={this.state.generateData.sendtomail}
                      onChange={(e) => this.handleEmailCheckBoxChange(e)}
                    ></input>
                  </div>
                  {this.state.generateData.sendtomail ? (
                    <div className="col-lg-4">
                      <label className="form-label fontstyle required">
                        To Email
                      </label>
                      <br></br>
                      <ReactMultiEmail
                        className="tomail"
                        emails={tomail}
                        onChange={(_emails) => {
                          this.setState({ tomail: _emails }, () => {
                            console.log("valu", $("div.tomail>input").val());
                          });
                        }}
                        getLabel={(email, index, removeEmail) => {
                          return (
                            <label
                              className="m-1"
                              key={index}
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: "14px",
                                wordBreak: "break-word",
                              }}
                            >
                              {email}
                              <span
                                style={{
                                  fontSize: "20px",
                                  verticalAlign: "middle",
                                  marginLeft: ".25rem",
                                }}
                                data-tag-handle
                                name="delete"
                                onClick={() => removeEmail(index)}
                              >
                                &times;
                              </span>
                            </label>
                          );
                        }}
                      />
                      <span
                        id="tomailErrMsg"
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="px-2 py-4">
                <label className="fo-title">Remark</label>

                <div
                  style={{
                    borderBottom: "2px solid #1E3A8A",
                    paddingTop: 5,
                  }}
                ></div>
                <div
                  className="px-4 pb-3 pt-1"
                  style={{
                    backgroundColor: "#F9F9F9",
                    borderRadius: 0,
                    border: "none",
                  }}
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <label className="form-label fontstyle required">
                        Remarks
                      </label>
                      <br></br>
                      <textarea
                        className="form-control"
                        style={{
                          resize: "none",
                          height: 50,
                          marginTop: 8,
                          borderRadius: 0,
                          borderColor: "#DEDDDD",
                        }}
                        rows={5}
                        autoComplete="off"
                        maxLength={250}
                        name="remark"
                        value={this.state.generateData.remark}
                        onChange={(e) => this.handleInputChangeReport(e)}
                        onBlur={(e) => $("#errorTextOrderNewRemarks").text("")}
                      ></textarea>
                      <span
                        id="chargeDescriptionErrMsg"
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="form-group search-btn-col mt-4"
                style={{ textAlign: "end" }}
              >
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  type="submit"
                  onClick={() => this.submitGenerateData()}
                >
                  {" "}
                  Submit{" "}
                </button>
                <button
                  className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                  type="button"
                  onClick={() => this.clearModelData()}
                >
                  {" "}
                  Cancel{" "}
                </button>
              </div>
            </div>
          </Modal>

          {/* {this.renderCardData()} */}
        </div>
        <div className="full-height">
          <div className="pt-3">
            <div className="row px-3 pb-3">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.BacktoPrevious()}
              >
                <div style={{ position: "relative" }}>
                  <span className="backarr">&larr;</span>{" "}
                  <span style={{ marginLeft: "18px" }}>Back</span>
                </div>
              </button>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header mb-0"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body flex"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Monthly Reports
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box mb-3">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      <div className="col-lg-5">
                        <div
                          className="autocomplete-wrappers"
                          style={{
                            zIndex:
                              this.state.openShipName && !Loading ? 99999 : 0,
                          }}
                        >
                          <label className="form-label">Ship Name</label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            open={!Loading ? this.state.openShipName : false}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openShipName = isOpen;
                              this.setState({});
                            }}
                            value={this.state.searchData.shipName}
                            inputProps={{
                              placeholder: "Ship Name",
                            }}
                            items={ShipNameList ?? []}
                            getItemValue={(item) => item.shipName}
                            shouldItemRender={this.renderShipNameTitle.bind(
                              this,
                            )}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${
                                  isHighlighted ? "selected-items" : ""
                                }`}
                              >
                                {item.shipName}
                              </div>
                            )}
                            onChange={(e) => this.handleAnnualSearchChange(e)}
                            onSelect={(value, item) =>
                              this.handleAnnualSelectChange(
                                value,
                                "shipName",
                                item.shipID,
                                "shipId",
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className={"col-lg-7"}>
                        <label className="form-label">Month</label>
                        <br></br>
                        <div className="row">
                          <div className="col-sm-6">
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={this.state.searchData.fromDate}
                                className="form-control date-picker"
                                placeholder="From"
                                name="fromDate"
                              ></input>
                              <DatePicker
                                selected={this.state.SelectedFromDate}
                                key={
                                  this.state.fromDatePickerIsOpen
                                    ? "open"
                                    : "closed"
                                }
                                onChange={this.handleFromDateChange}
                                showMonthYearPicker
                                dateFormat="MMMM yyyy"
                                openToDate={
                                  this.state.SelectedFromDate ||
                                  this.state.SelectedToDate ||
                                  new Date()
                                }
                                maxDate={
                                  this.state.SelectedToDate
                                    ? new Date(
                                        this.state.SelectedToDate.getFullYear(),
                                        this.state.SelectedToDate.getMonth() +
                                          1,
                                        0, // last day of month
                                      )
                                    : null
                                }
                                open={this.state.fromDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                popperPlacement={
                                  this.state.isMobile ? "top-end" : "bottom"
                                }
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={this.openFromDatePicker}
                              >
                                <button
                                  className="btn btn-default"
                                  style={{ height: "100%" }}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 margin">
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={this.state.searchData.toDate}
                                className="form-control date-picker"
                                placeholder="To"
                                name="toDate"
                              ></input>
                              <DatePicker
                                key={
                                  this.state.toDatePickerIsOpen
                                    ? "open"
                                    : "closed"
                                }
                                selected={this.state.SelectedToDate}
                                onChange={this.handleToDateChange}
                                showMonthYearPicker
                                dateFormat="MMMM yyyy"
                                openToDate={
                                  this.state.SelectedFromDate ||
                                  this.state.SelectedToDate ||
                                  new Date()
                                }
                                minDate={
                                  this.state.SelectedFromDate
                                    ? new Date(
                                        this.state.SelectedFromDate.getFullYear(),
                                        this.state.SelectedFromDate.getMonth(),
                                        1,
                                      )
                                    : null
                                }
                                open={this.state.toDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                popperPlacement={
                                  this.state.isMobile ? "top-end" : "bottom"
                                }
                                className="form-control date-picker w-5 hide-date"
                              />
                              {/* <DatePicker
                                onChange={this.handleToDateChange}
                                open={this.state.toDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                endDate={this.state.SelectedToDate}
                                minDate={this.state.SelectedFromDate}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="top-end"
                                className="form-control date-picker w-5 hide-date"
                              /> */}
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={this.openToDatePicker}
                              >
                                <button
                                  className="btn btn-default"
                                  style={{ height: "100%" }}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 col-sm-12 mt-3">
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          {/* {userRole == Role.client ||
                            userRole == Role.clientuser ||
                            userRole == Role.mmpl ? (<></>) : (
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn m-2"
                              type="button"
                              onClick={() => this.GenerateReport()}
                            >
                              {" "}
                              Generate Report{" "}
                            </button>
                          )} */}
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-1"
                            type="submit"
                            onClick={() => this.SearchCrew(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>

                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn m-1"
                            type="button"
                            onClick={() => this.ClearInput()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {reportsData ? (
              <MonthlyreportCards
                arraylist={reportsData.data}
                pageSize={reportsData.pagination.pageSize}
                totalRecords={
                  reportsData.pagination.totalcount
                    ? reportsData.pagination.totalcount
                    : 0
                }
                deleteReport={(item) => this.deleteReport(item)}
                setUpdatedState={(value) => this.GetReportList(value)}
              />
            ) : null}
          </div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ReportList: state.MasterScreenReducer.ReportSearchDetails,
    DeviceList: state.UserManageReducer.DeviceList || [],
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    TimeZoneNameList: state.UserManageReducer.TimeZoneNameList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MonthlyReports);
